<template>
  <div class="AiStar">
    <ai-typo as="span" class="sr-only">
      {{
        $t('accessibility.description.hotelStarRating', {
          numberOfStar: numberOfStar,
        })
      }}
    </ai-typo>
    <ai-icon
      v-for="index of numberOfStar"
      :key="`AiStar-element--${index}`"
      name="star"
      aria-hidden="true"
      :size="{ height: 15, width: 16 }"
      :class="[`AiStar-icon AiStar-icon--${variant}`]" />
  </div>
</template>

<script setup lang="ts">
import AiIcon from '../AiIcon/AiIcon.vue';
import AiTypo from '../AiTypo/AiTypo.vue';

export interface AiStarProps {
  numberOfStar: number;
  variant: 'positive' | 'inverse';
}

withDefaults(defineProps<AiStarProps>(), {
  variant: 'positive',
});
</script>
<style lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/mixins';
@use '@/assets/styles/utilities/constants';

.AiStar {
  display: flex;
  justify-content: center;
}

.AiStar-icon {
  margin-right: constants.$inner-01;

  &:last-child {
    margin-right: 0;
  }
}

.AiStar-icon--inverse {
  fill: colors.$white;
}
</style>
